<template>
    <div class="profile">
        <div class="title-contents">
            <div class="icon-holder">
                <img src="@/assets/icons/stats.svg" alt="">
            </div>
            <h2>Статистика</h2>
        </div>

        <div class="stat-loading" v-if="pending.stat">
            <img src="@/assets/illustrations/loading_circle.svg" alt="">
        </div>
        <div class="stat-error" v-else-if="error.stat || !stat">
            {{ error.stat }}
        </div>
        <div class="game-stats-list" v-else>
            <div class="line pc-hide"></div>
            <div class="single">
                <game_stats color="green" :data="stat.place">
                    блоков поставлено
                </game_stats>
                <game_stats color="blue" :data="stat.break">
                    блоков разрушено
                </game_stats>
                <game_stats color="purple" :data="stat.messages">сообщений <span class="nowrap">
                    в чате
                </span>
                </game_stats>
                <game_stats color="orange" :data="stat.joins">
                    входов<span class="nowrap"> на сервер</span>
                </game_stats>
            </div>
            <div class="line pc-hide"></div>

            <div class="details">
                <div class="gray-game-stats progress" :class="{empty: emptyKD}">
                    <progress_circle :progress="kills / (deaths + kills)" :size="pcVersion? 84 : 72"
                                     :round-line-cap="true" background="#0D1316"
                                     :value="Math.round(kills / (deaths || 1) * 100) / 100 || 0" :stokeWidth="7"
                                     :empty="emptyKD"/>
                    <div class="about">
                        <div class="info">
                            <div class="item">
                                <span class="title">Убийства</span>
                                <span class="number">{{ kills.toLocaleString() }}</span>
                            </div>
                            <div class="item">
                                <span class="title">Смерти</span>
                                <span class="number">{{ deaths.toLocaleString() }}</span>
                            </div>
                        </div>
                        <tag v-if="kills.position">{{ kills.position }} в топе</tag>
                    </div>
                </div>
                <hours_online :playTime="stat.playTime" class="pc-only"/>
            </div>
            <hours_online :playTime="stat.playTime" class="pc-hide"/>
        </div>

        <div class="line pc-only"></div>
        <div class="media-section">
            <div class="title-contents">
                <div class="icon-holder">
                    <img src="@/assets/icons/info.svg" alt="">
                </div>
                <h2>Об аккаунте</h2>
            </div>
            <div class="media">
                <div class="point">
                    <p>Почта</p>
                    <h3>{{ $auth.user().user.email || 'Не привязана' }}</h3>
                </div>
                <div class="point">
                    <p>ВКонтакте</p>
                    <a :href="vkLink" target="_blank" v-if="vk">
                        <h3 class="linker">
                            {{ vkInfo.first_name }}
                            {{ vkInfo.last_name }}
                        </h3>
                    </a>
                    <router-link tag="h3" :to="{name: 'security'}" class="linker" v-else>Привязать аккаунт</router-link>
                </div>
                <div class="point">
                    <p>Дата регистрации</p>
                    <h3>{{ $auth.user().user.firstlogin | date }}</h3>
                </div>
                <div class="point">
                    <p>Последний вход</p>
                    <h3>{{ $auth.user().user.lastlogin | date }}</h3>
                </div>
            </div>
            <div class="line"></div>
            <div class="exit">
                <h3 class="linker-red" @click="logout">
                    Выйти из аккаунта
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
import game_stats from '@/elements/game_stats.vue'
import progress_circle from '@/elements/progress_circle.vue'
import hours_online from '@/components/cabinet/content/profile/hours_online.vue'
import tag from '@/elements/tag.vue'
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import moment from "moment";

export default {
    name: "profile",
    components: {
        game_stats,
        progress_circle,
        tag,
        hours_online,
    },
    computed: {
        vk() {
            return this.$auth.user().user && this.$auth.user().user.vk;
        },
        vkLink() {
            return `//vk.com/id${this.vk}`;
        },
        vkInfo() {
            return this.getVkInfo(this.vk);
        },
        kills() {
            return this.stat ? this.stat.kills.count : '?'
        },
        deaths() {
            return this.stat ? this.stat.deaths.count : '?';
        },
        emptyKD() {
            return !(this.kills || this.deaths)
        },
        ...mapState('cabinet', ['stat', 'pending', 'error']),
        ...mapGetters('cabinet', ['getVkInfo']),
        ...mapGetters('window', ['pcVersion'])
    },
    methods: {
        logout(){
          this.$auth.logout();
          this.resetStore();
        },
        ...mapMutations('cabinet', ['resetStore']),
        ...mapActions('cabinet', ['getStat'])
    },
    created() {
        if (!this.stat) this.getStat()
    },
    filters: {
        date(time) {
            const t = parseInt(time);
            if (isNaN(t)) return "Вы еще не заходили на сервер";
            return moment(t).calendar(null, {
                sameElse: 'D MMMM YYYY[ в ]HH:mm'
            });
        }
    }
}
</script>

<style lang="scss">
.profile {
    display: flex;
    flex-direction: column;

    .game-stats-list {
        .single {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-gap: 12px;
            margin-bottom: 12px;
        }

        .details {
            display: grid;
            grid-template-columns: auto 1fr;
            grid-gap: 12px;

            .gray-game-stats {
                padding: 24px;
                border-radius: 4px;
                background-color: $bg_light_plus;
                display: flex;
                //flex-direction: column;
                align-items: flex-start;

                &.empty {
                    .about span {
                        color: $text_gray !important;
                    }
                }

                &.progress {
                    display: flex;
                    align-items: center;
                    padding: 6px 24px;

                    .about {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;

                        .info {
                            display: flex;
                            flex-direction: column;
                            margin-left: 15px;
                            padding-top: 16px;
                            padding-bottom: 12px;
                            padding-left: 12px;

                            .item {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                font-weight: 700;

                                &:nth-child(2n + 1) .title {
                                    color: $blue;
                                }

                                &:nth-child(2n) .title {
                                    color: $purple;
                                }

                                .title {
                                    position: relative;
                                    font-size: 14px;
                                    line-height: 18px;
                                    margin-bottom: 4px;
                                    padding-right: 20px;

                                    &::before {
                                        content: '•';
                                        position: absolute;
                                        left: -10px;
                                    }
                                }

                                .number {
                                    color: white;
                                }
                            }
                        }
                    }
                }
            }

            .progress-circle {
                svg {
                    filter: drop-shadow(0px 8px 12px rgba(110, 78, 240, 0.4));

                    .progress-indicator {
                        stroke: #46B2FA;
                    }

                    .static-circle {
                        stroke: #6E4EF0;
                    }
                }
            }
        }
    }

    .media {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 12px;
        grid-row-gap: 12px;

        p {
            margin-bottom: 6px;
        }
    }

    .media, .exit {
        h3 {
            display: inline-block !important;
        }
    }

    .line {
        margin: 32px 0;
    }

    @include tablet {
        .line {
            margin: 26px 0;
        }
        .media-section {

            margin: -32px;
            margin-top: 32px;
            padding: 32px;
            border-radius: 0 0 32px 32px;
            background-color: $bg_light_plus;
        }
        .game-stats-list {
            display: flex;
            flex-direction: column;

            .single {
                grid-template-columns: 1fr 1fr;
                grid-template-rows: 1fr 1fr;
                margin-bottom: 0;
            }

            .details {
                display: block;
                order: -1;

                .progress {
                    padding: 0;
                    background: none;
                    flex-direction: row;
                    align-items: center;

                    .about {
                        margin-left: 20px;

                        .info {
                            flex-direction: column;

                            .item {
                                flex-direction: row !important;
                                justify-content: space-between;
                                margin-right: 0 !important;

                                .title {
                                    margin-right: 42px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @include mobile {
        .media-section {
            margin: -24px;
            margin-top: 32px;
            padding: 24px;

            .media {
                display: flex;
                flex-direction: column;

                .point {
                    margin-bottom: 20px;

                    p {
                        font-size: 14px;
                        line-height: 17px;
                        margin-bottom: 4px;
                    }

                    h3 {
                        font-size: 16px;
                        line-height: 19px;
                    }
                }
            }

            .line {
                margin-top: 18px;
                margin-bottom: 12px;
            }
        }
        .game-stats-list {
            .line {
                margin: 20px 0;
            }

            .details .progress {
                .about {
                    max-width: 200px;
                    width: 100%;

                    .info {
                        width: 100%;

                        .item {
                            width: 100%;

                            .title {
                                margin-right: 42px;
                            }
                        }
                    }
                }
            }
        }
    }

    .stat-error {
        color: $red;
        font-size: 16px;
    }

    .stat-loading {
        margin-top: 8px;

        @keyframes circle-loading {
            from {
                transform: rotate(0)
            }
            to {
                transform: rotate(360deg)
            }
        }

        img {
            animation: circle-loading 2s infinite linear;
        }
    }
}
</style>
